import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { HiOutlineMail, HiOutlineLockClosed, HiOutlineLogin, HiOutlineExclamationCircle } from 'react-icons/hi';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [shake, setShake] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg('');

        const result = await login(email, password);
        
        if (result.success) {
            toast.success('¡Bienvenido al CMS!');
            navigate('/dashboard');
        } else {
            setErrorMsg(result.message);
            setEmail('');
            setPassword('');
            setShake(true);
            setTimeout(() => setShake(false), 600);
        }
        
        setLoading(false);
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="login-header">
                    <div className="login-logo">
                        <div className="logo-icon">
                            <HiOutlineLockClosed />
                        </div>
                    </div>
                    <h1>Fenine CMS</h1>
                    <p>Sistema Gestor de Contenido</p>
                </div>

                <form onSubmit={handleSubmit} className={`login-form${shake ? ' shake' : ''}`}>
                    <div className="form-group">
                        <label className="form-label">
                            <HiOutlineMail />
                            <span>Correo Electrónico</span>
                        </label>
                        <input
                            type="email"
                            className={`form-control${errorMsg ? ' input-error' : ''}`}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="tu@email.com"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            <HiOutlineLockClosed />
                            <span>Contraseña</span>
                        </label>
                        <input
                            type="password"
                            className={`form-control${errorMsg ? ' input-error' : ''}`}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                        />
                    </div>

                    {errorMsg && (
                        <div className="login-error-msg">
                            <HiOutlineExclamationCircle />
                            <span>{errorMsg}</span>
                        </div>
                    )}

                    <button type="submit" className="btn btn-primary btn-lg" disabled={loading} style={{ width: '100%' }}>
                        {loading ? (
                            <>
                                <div className="spinner" style={{ width: '18px', height: '18px', borderWidth: '2px' }}></div>
                                <span>Ingresando...</span>
                            </>
                        ) : (
                            <>
                                <HiOutlineLogin />
                                <span>Iniciar Sesión</span>
                            </>
                        )}
                    </button>
                </form>

                <div className="login-footer">
                    <p>Contacta al administrador si olvidaste tu contraseña</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
